module.exports = __webpack_public_path__ + "img/huxi_des_5.32e78fe1.jpg";